import { MarkerTypes } from '../types';
import { svgToUri } from '../utils';

import { deliveryLocationMarkerSvg } from './delivery-location-marker';
import { deliveryWorkMarkerSvg } from './delivery-work-marker';
import { destinationMarkerSvg } from './destination-marker';
import { driverMarkerSvg } from './driver-marker';
import { getStoreMarkerSvg } from './store-marker';
import { getStoreFavoriteMarkerSvg } from './store-marker-fav';
import { userMarkerSvg } from './user-marker';

export const MARKER_URIS: Record<MarkerTypes, string> = {
  [MarkerTypes.User]: svgToUri(userMarkerSvg),
  [MarkerTypes.UserManual]: svgToUri(userMarkerSvg),
  [MarkerTypes.Driver]: svgToUri(driverMarkerSvg),
  [MarkerTypes.DeliveryWork]: svgToUri(deliveryWorkMarkerSvg),
  [MarkerTypes.Destination]: svgToUri(destinationMarkerSvg),
  [MarkerTypes.DeliveryLocation]: svgToUri(deliveryLocationMarkerSvg),
  [MarkerTypes.StoreOpen]: svgToUri(getStoreMarkerSvg(MarkerTypes.StoreOpen)),
  [MarkerTypes.StoreOpenSelected]: svgToUri(getStoreMarkerSvg(MarkerTypes.StoreOpenSelected)),
  [MarkerTypes.StoreNotAvailable]: svgToUri(getStoreMarkerSvg(MarkerTypes.StoreNotAvailable)),
  [MarkerTypes.StoreNotAvailableSelected]: svgToUri(
    getStoreMarkerSvg(MarkerTypes.StoreNotAvailableSelected)
  ),
  [MarkerTypes.StoreFav]: svgToUri(getStoreFavoriteMarkerSvg(MarkerTypes.StoreFav)),
  [MarkerTypes.StoreFavNotAvailable]: svgToUri(
    getStoreFavoriteMarkerSvg(MarkerTypes.StoreFavNotAvailable)
  ),
} as const;

export const deriveMarkerIcon = (type: MarkerTypes): string => {
  const icon = MARKER_URIS[type];
  if (!icon) {
    throw new Error(`Unsupported type: ${type}`);
  }
  return icon;
};
